import React, { Children, forwardRef } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { renderChildren } from '@fiverr-private/ui_utils';
import { RadioGroupProps } from '../types';
import { filterProps } from '../../shared/utils';
import { useRadioGroup } from './hooks/useRadioGroup';

const RadioGroup = forwardRef<HTMLInputElement, RadioGroupProps>(
  ({ children, direction = 'column', value, onChange, onBlur, ...rest }, ref) => {
    const { stylingProps, restProps } = filterProps(rest);
    const { getExtendedProps } = useRadioGroup({ value, onChange });

    return (
      <Stack onBlur={onBlur} gap="2" direction={direction} width="fit-content" {...stylingProps}>
        {Children.map(Children.toArray(children), (child) =>
          renderChildren(child, { ...restProps, ...getExtendedProps(child as React.ReactElement), ref })
        )}
      </Stack>
    );
  }
);

RadioGroup.displayName = 'RadioGroup';
export default RadioGroup;
